import keycloakService from "../modules";
import setAuthToken from "../utils/setAuthToken";
export  const routeVerify=()=>{
     const token = keycloakService.getToken();
      const email = keycloakService.getUserInfo('email');
      const dob = keycloakService.getUserInfo('birthdate');
      const candidatename = keycloakService.getUserInfo('name');
      // const phoneNumber = keycloakService.getUserInfo('phone_number');

      sessionStorage.setItem('mhet_cnd_project', 'mhcet');
      sessionStorage.setItem('mhet_cnd_token', token);
      sessionStorage.setItem('mhet_mst_token', token);
      sessionStorage.setItem('mhet_cnd_email', email);
      sessionStorage.setItem('mhcet_dob',dob)
      sessionStorage.setItem('mhcet_name',candidatename)
      // sessionStorage.setItem('mhet_cnd_mobileno', phoneNumber);
      sessionStorage.setItem('uploaddetails', 'true');

      setAuthToken(token);
}